var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"content",attrs:{"id":"content"},on:{"scroll":_vm.scroll}},[_c('Banner'),_c('Info'),_c('Content',{attrs:{"scrollTop":_vm.scrollTop}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }